import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, IconModule } from '@hglobal/common';
import { environment } from '@pt/environment';

import { AuthService } from '../../auth.service';

@Component({
  selector: 'pt-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    ButtonModule,
    IconModule,
  ],
})
export class SigninComponent implements OnInit {
  readonly logoName = `${environment.shortName}-logo`;

  readonly #auth = inject(AuthService);

  ngOnInit(): void {
    this.#auth.addOneTap();
    this.#auth.addButton('google-btn-id');
  }
}
